var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseRoundedButton',{class:[
    _vm.$style.icon,
    _vm.$style.facebook
  ],on:{"click":function($event){return _vm.$emit('click')}}},[_c('font-awesome-icon',{class:_vm.$style.icon,attrs:{"icon":{ prefix: 'fab', iconName: 'facebook' },"size":"2x"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }